'use strict';

/**
 * Recursively replace undefined values with null
 */ function nullifyEmptyValues(values) {
    return JSON.parse(JSON.stringify(values, (_key, value)=>value != null ? value : null));
}

module.exports = nullifyEmptyValues;
